<template>
    <div id="areas" class="flex-x-center m-row">
        <Area
            v-for="(area, a) in process"
            :key="a"
            :id="ID(a)"
            :process="area"
            :totalAreas="process.length"
            :contentInitiated="contentInitiated"
            :index="a"
            :mobile="mobile"
            @content-initiated="$emit('content-initiated', $event)"
        />
    </div>
</template>

<script>
import Area from "@/components/Projects/Project/Detail/Process/Area.vue";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailProcess",
    props: {
        process: Array,
        contentInitiated: Boolean,
        mobile: Boolean
    },
    components: { Area },
    methods: {
        ID: function(index) {
            const id = `process-area-${index + 1}`;
            return !this.mobile ? id : `m-${id}`;
        }
    },
    emits: [ ...projectModel.emits ]
};
</script>